export default {
  INTEGRATION_RELAX: true,
  INTEGRATION_EVERYMATRIX: true,
  INTEGRATION_THREE_PI: true,
  INTEGRATION_GAE_BRIDGE: true,
  INTEGRATION_BETFAIR: true,
  INTEGRATION_GAN: true,
  INTEGRATION_LIGHTANDWONDER: true,
}
